import React, { ChangeEvent, FormEvent } from "react";

interface GlobalSearchInputFieldProps {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onSearch: () => void;
  onClear: () => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  isSearchApplied?: boolean;
  searchButtonLabel?: string;
  disableSearchButton?: boolean;
}

const GlobalSearchInputField: React.FC<GlobalSearchInputFieldProps> = ({
  value,
  onChange,
  onSearch,
  onClear,
  placeholder = "",
  className = "",
  disabled = false,
  isSearchApplied = false,
  searchButtonLabel = "Search",
  disableSearchButton = false,
}) => {
  const trimmedValue = value.trim();
  const hasSearchTerm = trimmedValue.length > 0;
  const showClearButton = hasSearchTerm || isSearchApplied;

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!disabled && hasSearchTerm) {
      onSearch();
    }
  };

  return (
    <div className={`flex flex-col ${className}`}>
      <form onSubmit={handleSubmit}>
        <div className="relative flex items-center">
          <div className="absolute inset-y-0 left-0 flex items-center pl-[6px] h-full pointer-events-none">
            <span className="material-symbols-outlined text-text-subtle text-[18px]">
              search
            </span>
          </div>
          <input
            type="text"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            className="w-full px-2 py-[10px] pl-[40px] pr-[120px] text-text-base text-[10px] font-normal rounded-t-lg border border-border-subtle rounded-b-lg bg-transparent focus:outline-none placeholder:text-text-header disabled:cursor-not-allowed disabled:opacity-60"
            style={{ outline: "none" }}
          />
          <div className="absolute inset-y-0 right-0 flex items-center gap-[4px] pr-[6px]">
            {showClearButton && (
              <button
                type="button"
                onClick={onClear}
                disabled={disabled}
                aria-label="Clear search"
                className="flex h-[24px] w-[24px] items-center justify-center rounded-full text-text-subtle hover:bg-bg-page-body disabled:cursor-not-allowed disabled:opacity-50"
              >
                <span className="material-symbols-outlined text-[16px]">
                  close
                </span>
              </button>
            )}
            <button
              type="submit"
              disabled={disabled || disableSearchButton || !hasSearchTerm}
              className="rounded-[8px] border border-border-button-secondary bg-bg-button-secondary px-[12px] py-[6px] text-[10px] font-semibold text-text-base disabled:cursor-not-allowed disabled:opacity-50"
            >
              {searchButtonLabel}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default GlobalSearchInputField;
